export const ACTION = {

    GET_MFBYTES_METADATA :'GET_MFBYTES_METADATA'
};


